import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './ScrollToTop';
import Home from './pages/Home';
import DataAnalytics from './pages/DataAnalytics';
import DataEngineering from './pages/DataEngineering';
import DataScienceAI from './pages/DataScienceAI';
import WhyUs from './pages/WhyUs';
import About from './pages/About';
import Blog from './pages/Blog';
import Contact from './pages/Contact';
import Apply from './pages/Apply';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Navigate to="/academy" replace />} />
            <Route path="/academy" element={<Home />} />
            <Route path="/academy/data-analytics-course" element={<DataAnalytics />} />
            <Route path="/academy/data-engineering-course" element={<DataEngineering />} />
            <Route path="/academy/data-science-ai-course" element={<DataScienceAI />} />
            <Route path="/academy/why-us" element={<WhyUs />} />
            <Route path="/academy/about" element={<About />} />
            <Route path="/academy/blog" element={<Blog />} />
            <Route path="/academy/contact" element={<Contact />} />
            <Route path="/academy/apply" element={<Apply />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;

